import 'css-chunksrc/client/scenes/strategicAxisCreation/styles.scss';export default {
  "strategicAxisCreation": "_strategicAxisCreation_1sdo6_1",
  "main": "_main_1sdo6_5",
  "footer": "_footer_1sdo6_14",
  "button": "_button_1sdo6_22"
};